document.documentElement.classList.add('js');
const elements = document.querySelectorAll('[data-animate]')

const observer = new IntersectionObserver(
  entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const delay = entry.target.getAttribute('data-animate-delay') || 0
        setTimeout(() => {
          entry.target.classList.add('animate')
        }, delay)
        observer.unobserve(entry.target)
      }
    })
  },
  { threshold: 0.1 },
)

elements.forEach(el => observer.observe(el))

document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.getElementById('menuToggle')
  const mobileNav = document.querySelector('.mobile-nav-wrapper')
  const closeButton = document.querySelector('.mobile-close')
  const body = document.body
  const headerLogo = document.querySelector('.header-logo')

  if (menuToggle && mobileNav && closeButton && headerLogo) {
    menuToggle.addEventListener('click', () => {
      const isActive = mobileNav.classList.toggle('active')
      body.classList.toggle('no-scroll', isActive)
      document.documentElement.classList.toggle('no-scroll', isActive)
      headerLogo.classList.toggle('active', isActive)
    })

    closeButton.addEventListener('click', () => {
      mobileNav.classList.remove('active')
      body.classList.remove('no-scroll')
      document.documentElement.classList.remove('no-scroll')
      headerLogo.classList.remove('active')
    })
  }
})

document.querySelectorAll('.mobile-toggle').forEach(toggle => {
  toggle.addEventListener('click', () => {
    const listItem = toggle.closest('li')
    const paragraph = listItem?.querySelector('p[data-animate]')

    if (paragraph) {
      paragraph.style.display =
        paragraph.style.display === 'none' || paragraph.style.display === '' ? 'block' : 'none'
    }

    toggle.classList.toggle('active')
  })
})

document.querySelectorAll('.outage-toggle').forEach(toggle => {
  toggle.addEventListener('click', () => {
    const expand = toggle.nextElementSibling
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true'

    toggle.setAttribute('aria-expanded', String(!isExpanded))
    expand?.toggleAttribute('hidden', isExpanded)
  })
})

document.querySelectorAll('.umbraco-forms-hidden[for]').forEach(label => {
  label.setAttribute('aria-hidden', 'true')
})

document.addEventListener('DOMContentLoaded', function () {
  const checkbox = document.querySelector(
    'input[type="checkbox"][name="b0aa0df5-c554-428f-872b-c5f3ce807789"]',
  )

  if (checkbox) {
    const visibleLabel = document.querySelector(`label[for="${checkbox.id}"]`)

    if (checkbox && visibleLabel) {
      checkbox.setAttribute('aria-labelledby', visibleLabel.id || 'consent-label')
      visibleLabel.id = visibleLabel.id || 'consent-label'
    }
  }
})

document.addEventListener('DOMContentLoaded', function () {
  const checkbox = document.querySelector(
    'input[type="checkbox"][name="b0aa0df5-c554-428f-872b-c5f3ce807789"]',
  )
  const hiddenLabel = document.querySelector(
    'label[for="b0aa0df5-c554-428f-872b-c5f3ce807789"].umbraco-forms-hidden',
  )

  if (hiddenLabel) {
    hiddenLabel.setAttribute('aria-hidden', 'true')
    hiddenLabel.style.display = 'none'
  }

  const visibleLabel = document.querySelector(
    'label[for="b0aa0df5-c554-428f-872b-c5f3ce807789"]:not(.umbraco-forms-hidden)',
  )

  if (visibleLabel) {
    checkbox.setAttribute('aria-labelledby', visibleLabel.id || 'consent-label')
    visibleLabel.id = visibleLabel.id || 'consent-label'
  }
})
